import { useIntegrationStatusQuery } from 'modules/bookkeep';
import { isIntegrationStatusWithIntegration } from 'modules/bookkeep/integration/status';
import { unwrapQuery } from 'src/core/api/unwrapQuery';

export const useAccountingCountry = () => {
  const integrationStatusQueryState = useIntegrationStatusQuery();
  const integrationStatus = unwrapQuery(integrationStatusQueryState);

  return integrationStatus &&
    isIntegrationStatusWithIntegration(integrationStatus)
    ? integrationStatus.accountingCountry
    : 'default';
};
